module.exports = __webpack_public_path__ + "img/interviewcancelled.ead575fd.svg";